import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useHistory, useParams } from 'react-router-dom';

import { useCreateQuestionWithOptionsMutation } from '@school_ify/schoolify-repository/src/teacher/types';
import { AssignmentQuestionTypesEnum } from '@school_ify/schoolify-repository/src/shared/types';

import { getQuestionTypeFromString } from 'utils/quiz';
import { CreateEditQuestionModel } from 'types/quiz';

import MultipleOptionsQuestion from '../shared/MultipleOptionsQuestion/MultipleOptionsQuestion';
import FillInBlankQuestion from '../shared/FillInBlankQuestion/FillInBlankQuestion';
import OpenQuestion from '../shared/OpenQuestion/OpenQuestion';

interface ParamsProps {
  questionType: string;
  quizId: string;
}

const CreateQuestion = () => {
  const { questionType, quizId } = useParams<ParamsProps>();
  const history = useHistory();

  const [createQuestionMutation] = useCreateQuestionWithOptionsMutation();
  const handleCreateQuestion = (model: CreateEditQuestionModel) => {
    createQuestionMutation({
      variables: {
        object: {
          assignment_id: quizId,
          title: model.title,
          content: model.content,
          type: getQuestionTypeFromString(questionType),
          assignment_question_options: {
            data: model.questionOptions,
          },
        },
      },
      onCompleted: () => history.push(`/quiz/edit/${quizId}`),
    });
  };

  const project = () => {
    switch (questionType) {
      case AssignmentQuestionTypesEnum.PICK_OPTIONS:
        return <MultipleOptionsQuestion createOrUpdateQuestion={handleCreateQuestion} />;
      case AssignmentQuestionTypesEnum.FILL_IN_BLANK:
        return (
          <DndProvider backend={HTML5Backend}>
            <FillInBlankQuestion createOrUpdateQuestion={handleCreateQuestion} />
          </DndProvider>
        );
      case AssignmentQuestionTypesEnum.OPEN_QUESTION:
        return <OpenQuestion createOrUpdateQuestion={handleCreateQuestion} />;
      default:
        return <></>;
    }
  };

  return project();
};

export default CreateQuestion;
